import { requestJson, requestMultipart } from "@/lib/api";

/** Painel de Resultados (fechamento mensal) — estritamente ADMIN no backend. */
export type FinanceResultsDashboard = {
  id: string;
  html: string | null;
  originalFilename: string | null;
  sizeBytes: number;
  uploadedByEmail: string;
  uploadedAt: string;
  versionCount: number;
};

const PATH = "/api/v1/finance/results-dashboard";

/** Versão vigente do painel; `null` quando nenhum painel foi enviado ainda (204). */
export async function fetchFinanceResultsDashboard(): Promise<FinanceResultsDashboard | null> {
  const data = await requestJson<FinanceResultsDashboard | undefined>(PATH);
  return data ?? null;
}

export function uploadFinanceResultsDashboard(file: File): Promise<FinanceResultsDashboard> {
  const form = new FormData();
  form.append("file", file);
  return requestMultipart<FinanceResultsDashboard>(PATH, form);
}
